/* eslint-disable no-unused-vars */
import { useMemo } from 'react';
import { Each, MenuItem, ParagraphWithTooltip } from 'components';
import { saveCampaignServiceAPI } from 'services/saveCampaign.service';
import * as S from './ChooseAppSection.styled';

const appIsSelected = (appSet, pba_number) => {
  return appSet.has(pba_number);
};

const filterApp = (app, searchValue) => {
  const fields = [app.pba_number, app.package_name, app.pba_name];
  return fields.some((field) =>
    field?.toString().toLowerCase().includes(searchValue.toString().toLowerCase()),
  );
};

export const SearchList = ({ onChange, selectedApps, searchValue$ }) => {
  const { custom_audience_publisher_apps, appMap } =
    saveCampaignServiceAPI.useGetCustomAudiencesForManagementQuery(undefined, {
      selectFromResult: (response) => {
        const appMap = new Map();
        const srsData = response.data.custom_audience_publisher_apps;
        srsData.forEach((app) => {
          appMap.set(app.pba_id, app);
        });
        return {
          ...response,
          custom_audience_publisher_apps: srsData,
          appMap,
        };
      },
    });
  const selectedAppsSet = new Set(selectedApps.map((app) => app.pba_id.toString()));

  const sorted_custom_audience = useMemo(() => {
    const selectedItems = [];
    const nonSelected = [];
    custom_audience_publisher_apps.forEach((app) => {
      if (filterApp(app, searchValue$.value)) {
        (selectedAppsSet.has(app.pba_id) ? selectedItems : nonSelected).push(app);
      }
    });
    return selectedItems.concat(nonSelected);
  }, [custom_audience_publisher_apps, searchValue$.value]);

  const appClick = (pba_id) => {
    const appData = appMap.get(pba_id);
    if (selectedAppsSet.has(pba_id)) {
      const newApps = selectedApps.filter((app) => app.pba_id !== pba_id);
      onChange(newApps);
    } else {
      onChange([...selectedApps, appData]);
    }
  };

  return (
    <S.SearchListBox className='search_list'>
      <Each
        fieldOfIndex='pba_number'
        of={sorted_custom_audience}
        render={(item, index) => {
          const { pba_name, pba_number, package_name, icon, pba_id } = item;

          return (
            <MenuItem
              isSelected={appIsSelected(selectedAppsSet, pba_id)}
              height={52}
              value={pba_id}
              key={pba_number}
              wrapStyle={{ width: '100%', minHeight: '100%', display: 'flex' }}
              onClick={appClick}
            >
              <S.ItemBox>
                <S.TitleBox>
                  <S.Title>
                    <ParagraphWithTooltip
                      text={pba_name}
                      isHighlight={true}
                      search={searchValue$.value}
                    />
                  </S.Title>
                  <S.SmallText>
                    <ParagraphWithTooltip
                      text={package_name?.trim() || 'package_name'}
                      isHighlight={true}
                      style={{ fontWeight: '400', fontSize: '12px', lineHeight: '16px' }}
                      search={searchValue$.value}
                    />
                  </S.SmallText>
                </S.TitleBox>
                <S.SmallText style={{ flexShrink: 0 }}>
                  App ID:{' '}
                  <S.DarkerText>
                    <ParagraphWithTooltip
                      text={pba_number}
                      isHighlight={true}
                      style={{
                        display: 'inline',
                        fontWeight: '400',
                        fontSize: '12px',
                        lineHeight: '16px',
                      }}
                      search={searchValue$.value}
                    />
                  </S.DarkerText>
                </S.SmallText>
              </S.ItemBox>
            </MenuItem>
          );
        }}
      />
    </S.SearchListBox>
  );
};
